import React from 'react';
import QuestionnaireEvaluation from '../../components/questionnaire-evaluation';
import currency from '../../modules/currency';

const RefiFullDashboard = ({
  viewer: {
    consultPath,
    advisor,
    products,
    activeLoan: { refiPurpose, purchasePrice, cashOutValue },
    borrower: { name, email },
    loan: { loanState, refiCurrentProduct },
    ...viewer
  },
  actionPipe,
  ...props
}) => {
  const purpose = refiPurpose === 'CashOut' ? 'cashoutRefinanceFull' : 'refinanceFull';
  const savings = currency.fromNumber((Number(purchasePrice) + Number(cashOutValue)) * 0.0075, 0);

  return (
    <QuestionnaireEvaluation
      scenario={'RefiFull'}
      consultPath={consultPath}
      products={products}
      advisor={advisor}
      name={name}
      email={email}
      state={loanState}
      purpose={purpose}
      viewer={viewer}
      actionPipe={actionPipe}
      reviewItems={[
        'Your rate quote options across multiple lenders.',
        'A comparison of multiple loan products.',
        ...(refiCurrentProduct === 'None'
          ? []
          : ['A savings estimate versus your current mortgage.'])
      ]}
      steps={['Submit Basic Information', 'Schedule a Review Call', 'Receive Your Offers']}
      savings={savings}
      {...props}
    />
  );
};

export default RefiFullDashboard;



// WEBPACK FOOTER //
// ./src/products/refi-full/dashboard.js